import "../../Styles/Galery.scss";
import React from "react";


import original_1 from "../../img/Germany/Gallery_1.jpeg";
import original_2 from "../../img/Germany/Gallery_2.jpeg";
import original_3 from "../../img/Germany/Gallery_3.jpg";
import original_4 from "../../img/Germany/Gallery_4.jpg";
import original_5 from "../../img/Germany/Gallery_5.jpeg";
import original_6 from "../../img/Germany/Gallery_6.jpg";
import original_7 from "../../img/Germany/Gallery_7.jpeg";
import original_8 from "../../img/Germany/Gallery_8.jpg";
import original_9 from "../../img/Germany/Gallery_9.jpg";
import original_10 from "../../img/Germany/Gallery_10.jpeg";
import original_11 from "../../img/Germany/Gallery_11.jpeg";
import original_12 from "../../img/Germany/Gallery_12.jpg";
import original_13 from "../../img/Germany/Gallery_13.jpg";
import original_14 from "../../img/Germany/Gallery_14.jpg";
import original_15 from "../../img/Germany/Gallery_15.jpg";
import original_16 from "../../img/Germany/Gallery_16.jpeg";
import original_17 from "../../img/Germany/Gallery_17.jpg";
import original_18 from "../../img/Germany/Gallery_18.jpg";
import original_19 from "../../img/Germany/Gallery_19.jpeg";
import original_20 from "../../img/Germany/Gallery_20.jpeg";
import original_21 from "../../img/Germany/Gallery_21.jpeg";

import ImageGallery from "react-image-gallery";
const images = [
    {
        original: original_1,
    },
    {
        original: original_2,
    },
    {
        original: original_3,
    },
    {
        original: original_4,
    },
    {
        original: original_5,
    },
    {
        original: original_6,
    },
    {
        original: original_7,
    },
    {
        original: original_8,
    },
    {
        original: original_9,
    },
    {
        original: original_10,
    },
    {
        original: original_11,
    },
    {
        original: original_12,
    },
    {
        original: original_13,
    },
    {
        original: original_14,
    },

    {
        original: original_15,
    },
    {
        original: original_16,
    },
    {
        original: original_17,
    },
    {
        original: original_18,
    },
    {
        original: original_19,
    },
    {
        original: original_20,
    },
    {
        original: original_21,
    },

];

function ItalyGallery() {
    return (
        <div className="pageContainer">
            <div className="gallery-container">
                <div className="image-gallery-wrapper pictures">
                    <ImageGallery
                        items={images}
                        disableThumbnailScroll={true}
                        showThumbnails={false}
                        showBullets={true}
                    />
                </div>
            </div>
        </div>
    );
}

export default ItalyGallery;
